import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ToolbarEventManagerService {
    constructor() {}

    onAvatarClick = new EventEmitter<boolean>();

    private toolbarEventSubject = new Subject<boolean>();
    public toolbarEventSubject$ = this.toolbarEventSubject.asObservable();

    onAvatarSubjectClick() {
        this.toolbarEventSubject.next(true);
    }
}
